import { RequestConfig } from '@/interface'

const PRIFIX = 'adminSysLog/'
const logConfig: RequestConfig = {
  // 查询系统登录日志列表页接口
  queryLoginLogPageList: {
    url: `${PRIFIX}queryLoginLogPageList`,
    method: 'post'
  },
  // 系统登录日志导出
  exportLoginLog: {
    url: `${PRIFIX}exportLoginLog`,
    method: 'post'
  },
  // 查看系统操作日志接口
  querySysLogPageList: {
    url: `${PRIFIX}querySysLogPageList`,
    method: 'post'
  },
  // 系统操作日志导出
  exportSysLog: {
    url: `${PRIFIX}exportSysLog`,
    method: 'post'
  },
  // 操作行为列表
  getBehaviorType: {
    url: `${PRIFIX}getBehaviorType`,
    method: 'get'
  },
  // 操作模块列表
  getModelType: {
    url: `${PRIFIX}getModelType`,
    method: 'get'
  }
}
export default logConfig
// /**
//  * 查询系统登录日志列表页接口
//  * @param {*} data
//  */
// export function queryLoginLogListAPI(data) {
//   return request({
//     method: 'post',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     },
//     data: data
//   })
// }

// /**
//  * 系统登录日志导出
//  * @param {*} data
//  */
// export function loginLogExportAPI(data) {
//   return request({
//     method: 'post',
//     data: data,
//     responseType: 'blob',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     },
//     timeout: 60000
//   })
// }

// /**
//  * 查看系统操作日志接口
//  * @param {*} data
//  */
// export function querySystemLogListAPI(data) {
//   return request({
//     method: 'post',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     },
//     data: data
//   })
// }

// /**
//  * 系统操作日志导出
//  * @param {*} data
//  */
// export function systemLogExportAPI(data) {
//   return request({
//     method: 'post',
//     data: data,
//     responseType: 'blob',
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     },
//     timeout: 60000
//   })
// }
